export const TripLocationType = {
  PickUp: 'Pick-up',
  DropOff: 'Drop-off'
};



// WEBPACK FOOTER //
// ./src/app/core/enums/trip-location.enum.ts